import {
  Box,
  Container,
  Heading,
  Breadcrumb,
  BreadcrumbItem,
} from "@chakra-ui/react";

import { ChevronRightIcon } from "@chakra-ui/icons";

//Components
import Header from "components/dashHeader";
import Sidemenu from "components/sidemenu";

import BreadcrumbLink from "components/BreadcrumbLink/BreadcrumbLink";

// import RequestVirtualCardSteps from "./Versions/v1";
import RequestVirtualCardv2 from "./Versions/RequestVirtualCardv2";
import { useState } from "react";
import StepsProvider from "components/Steps/provider";

const RequestCards = (props) => {
  const currentPage = "Card";

  const cards = props?.location?.state?.cards;

  const [state, setState] = useState({
    agreedToLimitations: false,
    preAgreement: false,
  });

  const handleState = (newState) => {
    setState({ ...state, ...newState });
  };

  const reset = () => {
    setState({
      agreedToLimitations: false,
      preAgreement: false,
    });
  };

  // useEffect(() => {
  //   console.log("MOUNTED");
  //   return () => {
  //     console.log("UNMOUNTED");
  //     setState({
  //       agreedToLimitations: false,
  //       preAgreement: false,
  //     });
  //   };
  // }, [setState]);

  return (
    <Box>
      <Sidemenu currentPage={currentPage} logoutUser={props.logout} />
      <Header />

      <Box className="cards">
        <Box
          className="page-container"
          p={["6em 0 !important", "6.5em 1.5em !important"]}
        >
          <Container maxW="container.xl">
            <Box px={["24px", "0", "0"]}>
              <Heading fontSize="3xl">Cards</Heading>

              <Breadcrumb separator={<ChevronRightIcon color="gray.500" />}>
                <BreadcrumbItem>
                  <BreadcrumbLink to="/dashboard/cards">Cards</BreadcrumbLink>
                </BreadcrumbItem>

                <BreadcrumbItem isCurrentPage>
                  <BreadcrumbLink isCurrentPage href="#">
                    Request Card
                  </BreadcrumbLink>
                </BreadcrumbItem>
              </Breadcrumb>
            </Box>

            <Box
              bg="white"
              border="1px solid #8688942f"
              // minH="681px"
              w="calc(100% - 25vw)"
              // w="100%"
              mt="32px"
              borderRadius="8px"
              p="24px"
            >
              <StepsProvider maxStep={3}>
                {/* <RequestVirtualCardSteps cards={cards} /> */}

                <RequestVirtualCardv2
                  cards={cards}
                  state={state}
                  reset={reset}
                  handleState={handleState}
                />
              </StepsProvider>
            </Box>
          </Container>
        </Box>
      </Box>
    </Box>
  );
};

export default RequestCards;
